import React from 'react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ru from 'date-fns/locale/ru';
import DateCustomInput from '../components/DateCustomInput'


class DatesLine extends React.Component {

    render () {
        const { dates, handleDateChange, removeDate } = this.props;

        return (
            <div className='dates'>
                {
                    dates && dates.map((item, i) => {
                        return (
                            <DatePicker
                                key={i}
                                customInput={<DateCustomInput index={i} removeDate={removeDate} label={item.label} />}
                                selected={new Date(item.date)}
                                onChange={(date) => handleDateChange(i, date)}
                                dateFormat="P"
                                locale={ru}
                            />
                        )

                    })
                }

            </div>

        )
    }
}


export default DatesLine;


// WEBPACK FOOTER //
// ./src/components/DatesLine.js